"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendModel = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var HTTPRequest_1 = require("./HTTPRequest");
var BackendModel = (function (_super) {
    tslib_1.__extends(BackendModel, _super);
    function BackendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._defaultPayload = {};
        return _this;
    }
    BackendModel.prototype.performHTTPRequest = function (path, payload, method, signed) {
        if (path === void 0) { path = "/"; }
        if (method === void 0) { method = "GET"; }
        if (signed === void 0) { signed = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, body, headers, authHeader;
            return tslib_1.__generator(this, function (_a) {
                url = this._defaultHost + (path.startsWith("/") ? path : "/" + path);
                body = tslib_1.__assign(tslib_1.__assign({}, this.getDefaultPayload()), payload);
                headers = {};
                if (signed) {
                    authHeader = this.getAuthorizationHeader();
                    if (authHeader) {
                        headers["Authorization"] = authHeader;
                    }
                }
                return [2, this.json(url, body, method, headers)];
            });
        });
    };
    BackendModel.prototype.post = function (path, data, signed) {
        if (signed === void 0) { signed = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, this.performHTTPRequest(path, data, "POST", signed)];
            });
        });
    };
    BackendModel.prototype.put = function (path, data, signed) {
        if (signed === void 0) { signed = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, this.performHTTPRequest(path, data, "PUT", signed)];
            });
        });
    };
    BackendModel.prototype.delete = function (path, data, signed) {
        if (signed === void 0) { signed = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, this.performHTTPRequest(path, data, "DELETE", signed)];
            });
        });
    };
    BackendModel.prototype.get = function (path, signed) {
        if (signed === void 0) { signed = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, this.performHTTPRequest(path, undefined, "GET", signed)];
            });
        });
    };
    BackendModel.prototype.getDefaultPayload = function () {
        return this._defaultPayload || {};
    };
    Object.defineProperty(BackendModel.prototype, "defaultHost", {
        get: function () {
            return this._defaultHost;
        },
        enumerable: false,
        configurable: true
    });
    BackendModel.prototype.getAuthorizationHeader = function () {
        return null;
    };
    BackendModel = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], BackendModel);
    return BackendModel;
}(HTTPRequest_1.HTTPRequest));
exports.BackendModel = BackendModel;
//# sourceMappingURL=BackendModel.js.map